export default __webpack_public_path__ + "static/media/powerExperienceIcon1.40ac3251.webp";